export default {
  account_id_required: "Account ID is required.",
  account_not_exists: "Invalid password.",
  accountIdRequired: "Session expired! Please login again to continue...",
  agent_comm_rate_required: "Agent commission rate is required.",
  agent_id_required: "Agent ID is required.",
  alphaNumOnly: "Alphanumeric only",
  atLeastThreeMatchToBetParlay: "At least mix three matches to bet in parlay.",
  atLeastTwoMatchToBetParlay: "At least mix two match to bet in parlay.",
  bet_amount_required: "Bet amount is required.",
  bet_id_required: "Bet ID is required.",
  betAmountRequired: "Bet amount is required.",
  betExists: "Bet already exists.",
  betLowerMin: "Your stake less than the min stake.",
  betNotExists: "Please place a valid bet to join the tournament.",
  betOverMax: "Your stake exceeds the max stake.",
  betOverMaxBet: "Your stake exceeds the max stake.",
  betOverMaxPerMatch: "Your stake exceeds the max stake.",
  betTypeRequired: "Bet type is required.",
  BLOCK: "Account has been blocked!",
  changeStakeMax: "Input stake amount been changed due to MAX limit.",
  changeStakeMin: "Input stake amount been changed due to MIN limit.",
  CLOSE: "Account has been closed!",
  close: "Account is closed! Please contact your upline to continue...",
  confirmNewPasswordRequired: "Confirm new password is required!",
  connectionFailed: "Failed to link wallet system.",
  containAlphaNum: "{fname} must have at least one alphabet and one number.",
  "createRoomFailed-1": "Create room failed 1.",
  "createRoomFailed-2": "Create room failed 2.",
  "createRoomFailed-3": "Create room failed 3.",
  credit_amount_required: "Credit amount is required.",
  currency_required: "Currency is required.",
  currencyNotSupported: "Currency not supported",
  currPasswordRequired: "Current password is required!",
  dataError: "Data Error",
  debit_amount_required: "Debit amount is required.",
  duplicate_credit_record: "Duplicate credit record.",
  duplicate_debit_record: "Odds Is Updating...",
  endDateRequired: "End date is required!",
  EsportsDisabled: "E-Sports Game Disabled",
  forbiddenAccess: "Forbidden Access",
  FREEZE: "Account has been freezed!",
  freeze: "Account is freeze! Please contact your upline to continue...",
  game_maintenance: "Game is under maintenance.",
  incompletedRequest: "Something goes wrong...",
  insufficient_balance: "Insufficient Balance",
  invalid_password: "Invalid password.",
  invalidBetAmount: "Invalid bet amount.",
  invalidBets: "This market is not available, please try other markets.",
  invalidCurrency: "Invalid currency to bet.",
  invalidleague: "Invalid league.",
  invalidMarketType: "Invalid market type provided.",
  invalidMatch: "Invalid match.",
  invalidMember: "Invalid member.",
  invalidOddsBall: "Odds Is Updating...",
  invalidOperator: "Invalid operator.",
  invalidPassword: "Invalid Password",
  invalidRoom: "Invalid room.",
  invalidRoomLimit: "Invalid room limit.",
  invalidRoomPassword: "Invalid PIN Code. PIN code must be 6 digit numbers.",
  invalidRoomRate: "Invalid room rate.",
  invalidRoomType: "Invalid room type.",
  invalidRTSMatchOdds: "Invalid RTS Match Odds.",
  invalidSession: "Session expired! Please login again to continue...",
  IPJoinedBefore: "IP joined before.",
  isAlpha: "{fname} accept only alphabet.",
  isAlphaNum: "{fname} accept only alphanumerics.",
  isEmail: "{fname} accept only valid email addresses.",
  isIpAddress: "{fname} accept only valid IPv4 addresses.",
  isMaxLength: "{fname} must be less than or equal to {fvalue} characters.",
  isMaxValue: "{fname} must be less than or equal to {fvalue}.",
  isMinLength: "{fname} must have at least {fvalue} characters.",
  isMinValue: "{fname} must have minimal of {fvalue}.",
  isNumeric: "{fname} accept only numerics.",
  isOutrightRequired: "Is outright is required!",
  // vuelidate
  isRequired: "Please enter a {fname}.",
  isSameAs: "{fname} must be same as {fname2}.",
  isUrl: "{fname} accept only URLs.",
  "joinFailed-1": "Join room failed 1.",
  "joinFailed-2": "Join room failed 2.",
  leagueIdRequired: "League ID is required!",
  liveCasinoDisabled: "Live Casino Disabled",
  liveMatchNotAllowed: "Live match not allowed.",
  //tournament
  login_id_not_exists: "Invalid login, please try to login again.",
  loginFailed: "Login failed, please try again later...",
  loginLimit: "You have login too frequent, please try again after 1 minute...",
  lotteryDisabled: "Lottery Disabled",
  marketTypeChanged: "Bet Slip has been removed due to market type changed.<br />Please select again from the market.",
  marketTypeRequired: "Market Type is required.",
  master_comm_rate_required: "Master commission rate is required.",
  master_id_required: "Master ID is required.",
  matchDateRequired: "Match date is required.",
  matchHide: "This market is not available, please try other markets.",
  matchLowerMin: "Match lower min error occured.",
  matchNotActive: "This match is not available, please try match markets.",
  matchNotAllowBet: "This market is not available, please try other markets.",
  matchOverMax: "Match over max error occured.",
  matchRequired: "Match is required.",
  maxMatch: "Maximum {max} matches selected!",
  maxParlayTicket: "Reach maximum ticket per parlay!",
  maxRoomLimit: "No. of Players must be equal or less than 30.",
  maxRoomRate: "Entry fee must be equal or less than 1000.",
  member_id_required: "Member ID is required.",
  member_wallet_not_exists: "Member wallet not exists.",
  memberExists: "Member already exist.",
  memberJoinedBefore: "You have already joined before, please take note that public free room only can join once.",
  minBetAmount: "Minimum bet amount error occured.",
  MiniGameDisabled: "Mini Game Disabled",
  minMatch: "Minimum 3 matches selected.",
  minRoomLimit: "No. of Players must be equal or more than 3.",
  minRoomRate: "Entry fee must be equal or more than 10.",
  new_login_id_exists: "Invalid nickname, please try to set different nickname.",
  newPasswordRequired: "New password is required!",
  nickNameRequired: "Nickname is required!",
  noMatchSelected: "Please select at least 1 match.",
  notSameAs: "{fname} and {fname2} cannot be the same.",
  NoUserAccessRight: "Permission denied! Please contact your upline to continue...",
  oddsDisplayInvalid: "Odds Is Updating...",
  oddsIsUpdating: "Odds Is Updating...",
  OK: "OK",
  pageNumberRequired: "Page number is required!",
  pageSizeRequired: "Page size is required!",
  passwordRequired: "Password is required!",
  passwordsNotMatch: "Passwords do not match!",
  permission_denied: "Permission denied.",
  pointsOverLimit: "Points over limit error occured.",
  rate_required: "Rate is required.",
  rateLowerMin: "Rate lower min error occured.",
  rateOverMax: "Rate over max error occured.",
  requestFailed: "Your connection is unstable. Please check your connection and try again.",
  requestLimit: "You have request too frequent.",
  requestPending: "Request pending...",
  result_exists: "Result already exists.",
  room_id_required: "Room ID is required.",
  roomClosed: "Room closed.",
  roomClosedNotAllowed: "Room closed not allowed.",
  roomEnded: "Room already ended.",
  roomEndedOrCancelled: "Room ended or cancelled.",
  roomExists: "Not allow to create more than 1 private room.",
  RoomExists: "Not allow to create more than 1 private room.",
  roomFull: "Room is already full.",
  roomIdRequired: "Room ID is required.",
  roomIsPublicFree: "Room is public free.",
  roomLimitLowerMin: "Room limit lower min error occured.",
  roomLimitOverMax: "Room limit over max error occured.",
  roomLimitRequired: "Room limit is required.",
  roomNotExists: "Room not exist.",
  roomOverMax: "Room over max error occured.",
  roomPasswordRequired: "PIN Code is required.",
  roomRateRequired: "Room rate is required.",
  roomTypeRequired: "Room type is required.",
  s_senior_comm_rate_required: "Super Senior commission rate is required.",
  s_senior_id_required: "Super Senior ID is required.",
  secondary_account_exists: "Your nickname already created.",
  selectLeague: "Please select at least 1 league",
  selectOption: "Please select a {fname}",
  senior_comm_rate_required: "Senior commission rate is required.",
  senior_id_required: "Senior ID is required.",
  session_expired: "Session expired! Please login again to continue...",
  session_not_exists: "Session expired! Please login again to continue...",
  sessionTokenRequired: "Session token is required.",
  shareholder_comm_rate_required: "Shareholder commission rate is required.",
  shareholder_id_required: "Shareholder ID is required.",
  slotDisabled: "Slot Disabled",
  sportsTypeRequired: "Sports type is required!",
  startDateRequired: "Start date is required!",
  SUSPEND: "Your account had changed to VIEW only.",
  suspend: "Account is suspend! Please contact your upline to continue...",
  systemError: "Internal System Error.",
  tournamentDisabled: "The tournament is disabled, please check contact your upline.",
  tournamentLeagueExists: "Tournament league exists.",
  tournamentMatchExists: "Tournament match exists.",
  transfer_id_required: "Transfer ID is required.",
  unableToGetBalanceAtTheMoment: "Internal Server Error.",
  usernameRequired: "Username is required!",
  workingDateRequired: "Working date is required!",
  matchNotStarted: "Match not started yet.",
  cashOutUnavailable: "Cashout unavailable.",
  errorCashoutAmount: "Cashout is updating...",
  invalidParameter: "Invalid parameter.",
  startTimeRequired: "Start Time is required.",
  endTimeRequired: "End Time is required.",
  oddsTypeIDRequired: "Odds Type is required.",
  commissionRequired: "Commission is required.",
  requestTimeRequired: "Request Time is required.",
  statusRequired: "Status is required.",
  invalidStartTime: "Invalid Start Time.",
  invalidEndTime: "Invalid End Time.",
  invalidOddsTypeID: "Invalid Odds Type.",
  invalidCommission: "Invalid Commission.",
  invalidRequestTime: "Invalid Request Time.",
  invalidStatus: "Invalid Status",
  invalidAlgoMatchInfo: "This market is closed, please try other markets. (-101)",
  invalidAlgoSliderLeagueInfo: "Invalid League Info.",
  invalidAlgoSliderMinutesWeight: "Invalid Minutes Weight.",
  invalidAlgoSliderBetType: "Invalid Bet Type.",
  invalidRTSRunningScoreDetails: "Invalid Running Score Details (RTS).",
  invalidProviderGoalTimeLine: "Invalid Provider Goal Time Line.",
  invalidSliderTimeRange: "Invalid Time Range.",
  invalidMOMatchOdds: "Match Odds is updating...",
  invalidProviderSlider: "Invalid TM Info.",
  invalidCombineBetTypeAndOddsFormat: "Invalid Combine Bet Type And Odds Format.",
  invalidMatchInformation: "Invalid Match Information.",
  marketClose: "This market is closed, please try other markets. ", 
  error: "Error",
  freeRoomNeedBet: "Please place a qualifying bet to unlock access to the free room.",
};
